<app-header></app-header>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Os seus pedidos relacionados foram processados</h1>

        <div class="row">

          <div class="col-12">
            <!-- TABELA -->
            @if (!resumoPedido) {
              <table class="table table-hover border-bottom mt-4">
                <caption>Tabela com listagem de pedidos</caption>
                <thead>
                  <tr>
                    <th scope="col">CNPJ</th>
                    <th scope="col">RAZÃO SOCIAL</th>
                    <th scope="col">TOTAL DE PRODUTOS</th>
                    <th scope="col">TOTAL DE TAXAS</th>
                    <th scope="col">TOTAL DE PEDIDO</th>
                    <th scope="col">TOTAL DE DESCONTOS</th>
                    <th scope="col">TOTAL A PAGAR</th>
                    <th scope="col">PREVISÃO DE ENTREGA</th>
                    <th scope="col">BAIXAR BOLETO</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- LINHA 1 -->
                  @for (importacao of resumoPedido; track importacao) {
                    <tr>
                      <td>{{importacao.dataImportacao.slice(0,10)}}</td>
                      <td>{{importacao.dataImportacao.slice(11,16)}}</td>
                      @if (importacao.descricaoStatus == 'FINALIZADO') {
                        <td>Importação concluída</td>
                      }
                      @if (importacao.descricaoStatus != 'FINALIZADO') {
                        <td>Importação concluída com problemas</td>
                      }
                      <td>{{importacao.descricaoFase | camelCase}}</td>
                      <td>{{importacao.descricaoTipoArquivoImportacao}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            }

            <!-- BOTÃO E TEXTO EXPLICATIVO  -->
            @if (resumoPedido) {
              <div class="w-100 text-center mt-5">
                <img src="/assets/img/success.png" alt="representando sucesso ao fazer pedido" width="100px">
                <h2 class="subtitulo mt-3">Seu pedido foi efetuado com sucesso.</h2>
                <div class="texto text-start mt-4">
                  <h4 class="subtitulo mb-4">O que eu faço agora?</h4>
                  <span class="passo-numero">1</span><p class="paragrafo pb-4">Aguarde a entrega do seu pedido que será realizada desde que o pagamento seja efetuado dentro do prazo.</p>
                  <span class="passo-numero">2</span><p class="paragrafo pb-4">A realização do pagamento em data anterior ou posterior à informada no pedido implicará a respectiva antecipação ou prorrogação da entrega na mesma quantidade de dias.</p>
                  <h4 class="subtitulo mt-4">Obrigado por escolher nossos serviços de Gestão de Vale Transporte!</h4>
                </div>
              </div>
            }

            <!-- LOADING ENQUANTO NÃO CONSULTA O PEDIDO -->
            @if (resumoPedido === null) {
              <div class="mt-4">
                <div class="text-center">
                  <output class="spinner-border c-primary">
                    <span class="visually-hidden">Consultando resumo do pedido ...</span>
                  </output>
                </div>
                <p class="legenda-spinner">Consultando resumo do pedido ...</p>
              </div>
            }

            @if (resumoPedido === false) {
              <div class="text-center">
                <img src="/assets/img/erro.png" alt="representando erro na consulta do resumo do pedido" width="200px">
                <p class="legenda-erro">Ocorreu um erro na consulta do resumo do pedido.</p>
              </div>
            }
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
